import { type SearchFiltersDraft } from "@/lib/search-filter-model"
import { mapSearchConfigToFiltersDraft, mapSearchFiltersToSearchPayload } from "@/utils/search-utils"
import { EditFiltersDialog } from "../edit-filters-dialog"
import { usePutSearchSearchId } from "openapi/api/endpoints"
import { BeginSearchRequest, GetSearchQueries200 } from "openapi/api/model"
import { toast } from "sonner"
import { useMemo } from "react"

interface EditFiltersOnResultsProps {
    searchConfig?: GetSearchQueries200
    onSearchUpdated: (searchHash: string) => void
}

const EditFiltersOnResults = ({ searchConfig, onSearchUpdated }: EditFiltersOnResultsProps) => {
    const { mutateAsync: updateSearch } = usePutSearchSearchId()

    const initialValues = useMemo(
        () => mapSearchConfigToFiltersDraft(searchConfig),
        [searchConfig],
    )

    const handleSubmit = async (filters: SearchFiltersDraft) => {
        try{
            if(!searchConfig?.root_search_id) throw new Error('Failed to resolve search id')
            const { p_hash } = await updateSearch({
                searchId:searchConfig.root_search_id,
                data:{
                    ...mapSearchFiltersToSearchPayload(filters),
                    prompt: searchConfig.prompt
                } as unknown as BeginSearchRequest 
            })
            if (p_hash) {
                onSearchUpdated(p_hash)
            }
        }catch(err){
            toast.error('Failed to initialize search; please adjust your filters and try again')
            throw err
        }
    }

    return (
        <EditFiltersDialog
            initialFilters={initialValues}
            onSubmit={handleSubmit}
            searchPrompt={searchConfig?.prompt}
        />
    )
}

export default EditFiltersOnResults
